import tippy from 'tippy.js';

tippy('[data-tippy-content]');
